import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUserContext } from '../../context/UserContext';
import { Select } from 'antd';
import { toast } from 'react-hot-toast';

const HeaderPanel = () => {
  const [mainPcbDevices, setMainPcbDevices] = useState([]);
  const [testPcbDevices] = useState([
    { id: 'gaugeTest_E831CD803100', name: 'gaugeTest_E831CD803100' },
    { id: 'gaugeTest_E831CD803101', name: 'gaugeTest_E831CD803101' },
    { id: 'gaugeTest_E831CD803102', name: 'gaugeTest_E831CD803102' },
  ]);
  const [scenarios, setScenarios] = useState([]);
  const [selectedMainPcb, setSelectedMainPcb] = useState('');
  const [selectedTestPcb, setSelectedTestPcb] = useState('');
  const [selectedScenario, setSelectedScenario] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { isPcbTesting, startPcbTesting, stopPcbTesting, deviceIds } = useUserContext();

  useEffect(() => {
    const fetchMainPcbDevices = async () => {
      setIsLoading(true);
      try {
        console.log("deviceIds", deviceIds);
        const mappedDevices = Array.isArray(deviceIds)
          ? deviceIds.map((id) => ({ id, name: id }))
          : [];
        setMainPcbDevices(mappedDevices);
      } catch (error) {
        console.error('Error fetching main PCB devices:', error);
        setMainPcbDevices([
          { id: '10F820BD9710', name: '10F820BD9710' },
          { id: 'D8D020BD9710', name: 'D8D020BD9710' },
          { id: '10F820BD9712', name: '10F820BD9712' },
          { id: 'AC8E0ACD31E8', name: 'AC8E0ACD31E8' },
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    const loadScenarios = () => {
      try {
        const scenarioData = require('./dependency_scenarios.json');
        setScenarios(scenarioData);
      } catch (error) {
        console.error('Error loading scenarios:', error);
      }
    };

    fetchMainPcbDevices();
    loadScenarios();
  }, []);

  const isStartButtonDisabled = !selectedMainPcb || !selectedTestPcb || !selectedScenario;
  const isSendFixValuesDisabled = !selectedMainPcb || !selectedTestPcb;

  const handleSendFixValues = () => {
    axios.post(process.env.REACT_APP_API_URL + '/testing/send-fix-params', {
      testPcbDevice: selectedTestPcb,
    })
    .then((response) => {
     toast.success('Fix values sent successfully');
      console.log('Fix values sent successfully:', response.data);
    })
    .catch((error) => {
        toast.error('Error sending fix values');
      console.error('Error sending fix values:', error);
    });
  };

  return (
    <div className="fixed top-[5rem] w-full z-10 bg-white shadow-sm">
      <div className="container mx-auto p-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
            <div className="w-full">
              
              <Select
                showSearch
                placeholder={isLoading ? 'Loading devices...' : 'Select Main PCB'}
                value={selectedMainPcb || undefined}
                onChange={setSelectedMainPcb}
                disabled={isLoading || isPcbTesting}
                options={mainPcbDevices.map((device) => ({ value: device.id, label: device.name || device.id }))}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: '100%' }}
                size="large"
              />
            </div>

            <div className="w-full">
             
              <div className="relative">
                <select
                  value={selectedTestPcb}
                  onChange={(e) => setSelectedTestPcb(e.target.value)}
                  disabled={isPcbTesting}
                  className="block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 bg-white text-gray-800 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                >
                  <option value="">Select Test PCB</option>
                  {testPcbDevices.map((device) => (
                    <option key={device.id} value={device.id}>
                      {device.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="w-full">
              <div className="relative">
                <select
                  value={selectedScenario}
                  onChange={(e) => setSelectedScenario(e.target.value)}
                  disabled={isPcbTesting}
                  className="block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 bg-white text-gray-800 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                >
                  <option value="">Select Scenario</option>
                  {scenarios.map((scenario) => (
                    <option key={scenario.id} value={scenario.id}>
                      {scenario.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto mt-4 md:mt-0 md:min-w-[320px]">
            

            <button
              onClick={() => {
                if (isPcbTesting) {
                  stopPcbTesting();
                } else {
                  startPcbTesting(selectedMainPcb, selectedTestPcb, selectedScenario);
                }
              }}
              disabled={(!isPcbTesting && isStartButtonDisabled) || isLoading}
              className={`
                min-w-[120px] h-11 px-4 rounded-lg font-medium text-white shadow-sm border-2 border-transparent
                ${isPcbTesting
                  ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500 border-red-200'
                  : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 border-blue-200'}
                ${(!isPcbTesting && isStartButtonDisabled) || isLoading
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:shadow-lg transition-all duration-200 transform hover:scale-105'}
                focus:outline-none focus:ring-2 focus:ring-offset-2 text-sm font-semibold
                flex items-center justify-center whitespace-nowrap
              `}
            >
              {isPcbTesting ? (
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                  Stop Test
                </span>
              ) : (
                'Start Test'
              )}
            </button>

            <button
              onClick={handleSendFixValues}
              disabled={isSendFixValuesDisabled || isLoading}
              className={`
                min-w-[140px] h-11 px-4 rounded-lg font-medium text-white shadow-sm border-2 border-transparent
                bg-green-600 hover:bg-green-700 focus:ring-green-500
                ${isSendFixValuesDisabled || isLoading
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:shadow-md transition-all duration-200 transform hover:scale-105'}
                focus:outline-none focus:ring-2 focus:ring-offset-2 text-sm whitespace-nowrap
                flex items-center justify-center
              `}
            >
              Send Fix Values
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderPanel;